module.exports = __webpack_public_path__ + "static/kasuien02-2dface702408c90424a48342a18a1a75.jpg";